import { CivilUnionAnscNotificationsNonResidentMutationCrumbs } from 'mutation/constants/ansc-notifications.crumbs';
import { Fragment, ReactElement } from 'react';
import PersonSearchCivilUnionNonResidentAnscNotificationCivilStatusShared from 'shell/components/shared/ansc-notifications/research-civil-union-non-resident/edit-person-search';
import { IdAmbito } from 'shell/constants/id-ambito';

const PersonSearchCivilUnionNonResidentAnscNotificationCivilStatusPage = (): ReactElement => {
  return (
    <Fragment>
      <PersonSearchCivilUnionNonResidentAnscNotificationCivilStatusShared
        scope={IdAmbito.Mutazioni}
        items={CivilUnionAnscNotificationsNonResidentMutationCrumbs()}
      />
    </Fragment>
  );
};

PersonSearchCivilUnionNonResidentAnscNotificationCivilStatusPage.displayName =
  'Research CivilUnion Non Resident Notifications Page component';

export default PersonSearchCivilUnionNonResidentAnscNotificationCivilStatusPage;
